/** @format */

import { Loading, Modal, Tag, TextInput } from "carbon-components-react";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import UIShell from "../../components/UIShell";
import UIShellPagination from "../../components/UIShellPagination";
import PageHelper from "../../helpers/Pagehelper";
import { BG_COLORS, IS_PUBLISHED, STATUSES_UP } from "../../utils/constants";
import {
  bulkDeleteCategory,
  fetchAllCategory,
  updateCategory,
} from "../../redux/actions/categoryAction";
import { bulkDeleteJob, fetchAllJob } from "../../redux/actions/jobAction";

function JobPage({ isLoading }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [isLoadingData, setIsLoadingData] = useState(true);

  const [paginationContent, setPaginationContent] = useState({
    query: "",
    page: 0,
    limit: 20,
    total: 0,
    totalItems: 0,
    rows: [],
  });

  const [modalContent, setModalContent] = useState({
    modalHeading: "",
    isOpen: false,
    categoryId: undefined,
    categoryName: undefined,
  });

  const headers = [
    {
      key: "title",
      header: "Title",
    },
    {
      key: "status",
      header: "Status",
    },
  ];

  const mapToColumn = (row) => {
    return {
      _id: row._id,
      title: row.title,
      status: (
        <Tag
          type={
            row.status === STATUSES_UP.PUBLISHED
              ? BG_COLORS.GREEN
              : BG_COLORS.GRAY
          }
        >
          {row.status === STATUSES_UP.PUBLISHED
            ? IS_PUBLISHED.PUBLISHED
            : IS_PUBLISHED.UNPUBLISHED}
        </Tag>
      ),
    };
  };

  const updateCategoryDetail = () => {
    dispatch(
      updateCategory(
        {
          categoryId: modalContent.categoryId,
          categoryName: modalContent.categoryName,
        },
        () => {
          // reset modal content
          setModalContent({
            modalHeading: "",
            isOpen: false,
            categoryId: undefined,
            categoryName: undefined,
          });

          dispatch(
            fetchAllCategory(
              { query: "", page: 1, limit: paginationContent.limit },
              ({ totalFiltered, total }) =>
                setPaginationContent((v) => ({
                  ...v,
                  skip: totalFiltered,
                  total,
                  totalItems: PageHelper.getTotalItems(
                    total,
                    paginationContent.limit
                  ),
                  page: 1,
                  query: "",
                }))
            )
          );
        }
      )
    );
  };

  const bulkDelete = async (_items) => {
    dispatch(
      bulkDeleteJob(
        {
          jobIds: _items.map((v) => ({
            _id: v.id,
          })),
        },
        () => {
          fetch({ query: "", page: 0, limit: paginationContent.limit });
        }
      )
    );
  };

  const viewCategoryDetail = (_data) => {
    const jobId = _data[0].id.split(":")[0];
    history.push(`/jobs/form/${jobId}`);
  };

  const paginationChange = async (_newPage) => {
    fetch({
      query: paginationContent.query,
      page: _newPage,
      limit: paginationContent.limit,
    });
  };

  const searchTable = async (e) => {
    const { value } = e.target;

    fetch({ query: value, page: 0, limit: paginationContent.limit });
  };

  const fetch = ({ query, page, limit }) => {
    setIsLoadingData(true);
    dispatch(
      fetchAllJob(
        { query, page, limit },
        ({ filteredData, totalFiltered, total }) => {
          setPaginationContent((v) => ({
            ...v,
            skip: totalFiltered,
            query,
            limit,
            page,
            total,
            totalItems: PageHelper.getTotalItems(total, limit),
            rows: filteredData.map(mapToColumn),
          }));
          setIsLoadingData(false);
        }
      )
    );
  };

  useEffect(() => {
    fetch(paginationContent);
  }, []);

  return (
    <UIShell breadcrumbs={[{ name: "Home", link: "/" }, { name: "Jobs" }]}>
      {isLoadingData && <Loading />}
      <UIShellPagination
        dataTableList={paginationContent.rows}
        headers={headers}
        searchTable={searchTable}
        bulkDelete={bulkDelete}
        createForm={() => history.push("/jobs/form")}
        viewDetail={viewCategoryDetail}
        paginationChange={paginationChange}
        totalItems={paginationContent.totalItems}
        page={paginationContent.page}
        withExpander={true}
        title="Jobs List"
        description="All jobs from companies"
      />

      <Modal
        modalHeading={modalContent.modalHeading}
        modalLabel="Job details"
        primaryButtonText="Update"
        primaryButtonDisabled={isLoading}
        secondaryButtonText="Cancel"
        open={modalContent.isOpen}
        onRequestSubmit={() => updateCategoryDetail()}
        onRequestClose={() => setModalContent((v) => ({ ...v, isOpen: false }))}
      >
        <p style={{ marginBottom: "1rem" }}>
          Category can be nested up to 3 levels
        </p>

        <TextInput
          data-modal-primary-focus
          labelText="Company Name"
          placeholder="e.g. github.com"
          value={modalContent.categoryName}
          onChange={(_v) =>
            setModalContent((v) => ({ ...v, categoryName: _v.target.value }))
          }
          style={{ marginBottom: "1rem" }}
        />
      </Modal>
    </UIShell>
  );
}

const mapStateToProps = (state) => {
  return {
    dataTableList: state.jobReducer.dataTableList,
    isLoading: state.uxReducer.isLoading,
  };
};

export default connect(mapStateToProps)(JobPage);
